/*
 * Constants.
 */

// NOTE: For now this includes the START and END node, but once pricing plans come into play we may need to omit them.
export const maxChatBotNodesCount = 700;

export const maxBranchesPerNode = 12;

// Since multiple choice nodes will have 1 branch per option, the max number of options
// is equal to the max number of branches we allow per node.
export const multiChoiceMaxOptions = maxBranchesPerNode;
export const multiChoiceMinOptions = 2;
export const parseMinOptions = 1;
export const parseMaxOptions = 7;

export const parseTextMaxKeywordSetSize = 60;

// Max number of CUSTOM_FIELDS node fields that legacy growth plans & premium plans have access to.
export const customFieldPremiumFeaturesMaxOptions = 3;
// Max number of CUSTOM_FIELDS node fields that all other plans have access to.
export const customFieldBasicFeaturesMaxOptions = 2;

export const maxMessageContentLength = 5000;
export const maxPromptContentLength = 5000;
